<template>
    <div class="statsHeader">
        <div>
             <div class="total-sub-block">
                <b class="total-count-label">{{ totalGoal }}</b>
                <div class="space"/>
            </div>
            <div class="total-sub-block">
                <div class="event-label">{{ $t("dataStatistics.jinQiu") }}</div>
                <img src="~@/assets/football/players/event_goal.png" alt="">
            </div>
        </div>
        <div class="total-segment"></div>
        <div>
             <div class="total-sub-block">
                <b class="total-count-label">{{ totalPointSphere }}</b>
                <div class="space"/>
            </div>
            <div class="total-sub-block">
                <div class="event-label">{{ $t("dataStatistics.dianQiu") }}</div>
                <img src="~@/assets/football/players/event_penalty.png" alt="">
            </div>
        </div>
        <div class="total-segment"></div>
        <div>
             <div class="total-sub-block">
                <b class="total-count-label">{{ totalUron }}</b>
                <div class="space"/>
            </div>
            <div class="total-sub-block">
                <div class="event-label">{{ $t("dataStatistics.wuLong") }}</div>
                <img src="~@/assets/football/players/event_wulong.png" alt="">
            </div>
        </div>
        <div class="total-segment"></div>
        <div>
             <div class="total-sub-block">
                <b class="total-count-label">{{ totalYellowCard }}</b>
                <div class="space"/>
            </div>
            <div class="total-sub-block">
                <div class="event-label">{{ $t("dataStatistics.huangPai") }}</div>
                <img src="~@/assets/football/players/event_yellow.png" alt="">
            </div>
        </div>
        <div class="total-segment"></div>
        <div>
             <div class="total-sub-block">
                <b class="total-count-label">{{ totalRedCard }}</b>
                <div class="space"/>
            </div>
            <div class="total-sub-block">
                <div class="event-label">{{ $t("dataStatistics.hongPai") }}</div>
                <img src="~@/assets/football/players/event_red.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'statsHeader',
  props: {
    dataArray: {
      type: Array,
      default: () => Array
    }
  },
  watch: {
    dataArray (val) {
      this.totalGoal = 0
      this.totalPointSphere = 0
      this.totalUron = 0
      this.totalYellowCard = 0
      this.totalRedCard = 0
      val.forEach((item, index, array) => {
        this.totalGoal += parseInt(item.goal)
        this.totalPointSphere += parseInt(item.pointSphere)
        this.totalUron += parseInt(item.uron)
        this.totalYellowCard += parseInt(item.yellowCard)
        this.totalRedCard += parseInt(item.redCard)
      })
    }
  },
  data () {
    return {
      totalGoal: 0,
      totalPointSphere: 0,
      totalUron: 0,
      totalYellowCard: 0,
      totalRedCard: 0
    }
  }
}
</script>

<style lang="sass" scoped>
// 分割线
.total-segment
    background-color: #dcdcdc
    width: 1px
    height: 15px

// 总数据的容器
.statsHeader
    display: flex
    justify-content: space-between
    align-items: center
    padding: 10px 15px 15px 15px
    img
        width: 14.5px
        height: 14.5px
        padding-left: 4px

// 数量和“图标”的容器，事件和图标的容器。这里的“图标”是占位为了文字与下方的文字对齐
.total-sub-block
    display: flex
    justify-content: center
    font-size: 12px
    color: #000000
    align-items: center

// 事件得分数量
.total-count-label
    font-size: 16px
    padding-bottom: 3px
.space
  width: 14.5px
  height: 14.5px
  padding-left: 4px
</style>
